import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';
import { catchError, EMPTY } from 'rxjs';
import { User } from '../user.model';
import { UsersService } from '../users.service';

export const userDetailResolver: ResolveFn<User> = (route) => {
  const usersService = inject(UsersService);
  const router = inject(Router);

  const id = route.paramMap.get('id');
  if (!id) {
    router.navigate(['/utilisateurs']);
    return EMPTY;
  }

  return usersService.getUserById(id).pipe(
    catchError(() => {
      router.navigate(['/utilisateurs']);
      return EMPTY;
    }),
  );
};
